import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HelpGuideRoutingModule } from './help-guide-routing.module';
import { HelpGuideComponent } from './help-guide.component';
import { DxDataGridModule, DxSelectBoxModule, DxTextBoxModule, DxCheckBoxModule, DxTagBoxModule, DxAutocompleteModule, DxTabPanelModule } from 'devextreme-angular';
import { I18nModule } from 'app/shared/i18n/i18n.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { FileUploadModule } from 'ng2-file-upload';

@NgModule({
  declarations: [HelpGuideComponent],
  imports: [
    CommonModule,
    HelpGuideRoutingModule,
    DxDataGridModule,
    I18nModule,
    ReactiveFormsModule,
    FormsModule,
    DxSelectBoxModule,
    DxTextBoxModule,
    DxCheckBoxModule,
    DxTagBoxModule,
    DxAutocompleteModule,
    DxTabPanelModule,
    FileUploadModule
  ]
})
export class HelpGuideModule { }
